<template>
<v-card flat tile class="grey lighten-4 pb-1" >
  <request-status :request="req" />
  <v-overlay absolute v-model="req.loading" >
    <center>
      <v-progress-circular indeterminate
        :size="70"
        color="amber" /><br/><br/>
      Loading
    </center>
  </v-overlay>

  <v-toolbar dense flat >
    <v-toolbar-title >Billing</v-toolbar-title>
    <v-spacer/>
    <!-- <v-btn small outlined color="primary" >Account</v-btn>
    <v-btn small outlined class="ml-2" color="primary" >History</v-btn>

    <v-divider vertical class="mx-2" /> -->

    <v-btn icon small @click="get" >
      <v-icon small>mdi-reload</v-icon>
    </v-btn>
  </v-toolbar>
  <v-divider/>

  <!-- <billing-history /> -->

  <v-tabs v-if="businesses && businesses.length > 1" >
    <v-tab v-for="biz in businesses" :key="biz.id" >
      {{ biz.name }}
    </v-tab>
  </v-tabs>
  <!-- <pre v-text="businesses" class="caption" /> -->

  <v-alert tile v-if="result && result.is_active === false" type="info"  >
    <request-status :request="reactivateReq" @ok="get" />
    This account has been cancelled. You will not be charged.
    <v-btn @click="reactivate" :loading="reactivateReq.loading" outline >Reactivate account</v-btn>
  </v-alert>

  <v-card outlined :disabled="!result.is_active" class="mx-3 mt-3" >

     <v-list>
      <v-list-item >
        <v-list-item-content>
          <v-list-item-title>
            Base Price <small>(Includes first practitioner)</small>
            <v-chip x-small label outlined
              v-if="result.package"
              class="ml-2"
              color="info" >{{ result.package.title }}</v-chip>
          </v-list-item-title>
          <v-list-item-subtitle
            v-if="result.custom_price_reason"
            v-text="result.custom_price_reason" />
        </v-list-item-content>
        <v-list-item-action >
          {{ formatCurrency(null, result.calculated_base_price) }}
          <v-list-item-action-text
            v-if="parseFloat(result.calculated_base_price) !== parseFloat(standardPackagePrice)"
            class="grey--text" >
            <s>{{ formatCurrency(null, standardPackagePrice) }}</s>
          </v-list-item-action-text>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <v-footer class='overline py-0 grey lighten-2' >
      Person responsible for account:
      <v-spacer/>
      <v-chip label small outlined >
      {{accountOwner.first_name}} {{accountOwner.last_name}}
      </v-chip>
    </v-footer>

  </v-card>

  <v-card outlined
    :disabled="!result.is_active"
    v-if="seats && seats.length > 0"
    class="mx-3 mt-3" >

    <v-card-title class='overline py-0 grey lighten-2' >
      <strong>Additional Members</strong>
      <v-spacer/>
      <v-btn x-small outlined
        to="/settings/team/new/"
        color="primary" >Add teammate</v-btn>
    </v-card-title>
    <v-divider/>


    <v-list >
      <template v-for="seat in activeSeats" >
        <v-list-item
          :key="seat.id" >
          <v-list-item-content>
            <v-list-item-title>
              {{seat.practitioner.user.first_name}} {{seat.practitioner.user.last_name}}
              <v-chip x-small label color="error" v-if="seat.active===false" >deactivated</v-chip>
              <v-chip x-small label outlined color="info" class="ml-2 float-right" >{{seat.package.title}}</v-chip>
              <v-chip x-small label outlined color="info" class="ml-2 float-right" >{{seat.role.title}}</v-chip>
            </v-list-item-title>
            <v-list-item-subtitle
              v-if="seat.custom_price_reason"
              v-text="seat.custom_price_reason" />
          </v-list-item-content>
          <v-list-item-action >
            {{ formatCurrency(null, seat.calculated_seat_price) }}
            <v-list-item-action-text class="grey--text"
              v-if="seat.calculated_seat_price != seat.standard_seat_price" >
              <s>{{ formatCurrency(null, seat.standard_seat_price) }}</s>
            </v-list-item-action-text>
          </v-list-item-action>
        </v-list-item>
        <v-divider :key="`div-${seat.full_name}`"/>
      </template>
    </v-list>

    <v-card-actions class="grey lighten-4" >
      <strong>Sub-total</strong>
      <v-spacer/>
      <strong>{{ formatCurrency(null, seatPriceTotal) }}</strong>
    </v-card-actions>
  </v-card>

  <v-card flat outlined dark class="ma-3"  >
    <v-card-actions >
      <strong>Total</strong>
      <v-spacer/>
      <strong>
      {{ formatCurrency(null, result.grand_total) }}
      </strong>
    </v-card-actions>
    <v-footer class="caption text-right">
      <v-spacer/>
      Price due on your next billing cycle<br/>
      You account is charged on the {{result.pay_day_of_month}}st day of the month
    </v-footer>
  </v-card>

  <v-card v-if="deactivatedSeats && deactivatedSeats.length > 0" class="ma-3" tile flat >
    <v-card-title >Deactivated seats</v-card-title>
    <v-list dense class="pa-0">
      <v-list-item v-for="seat in deactivatedSeats" :key="seat.id" >
        <v-list-item-content>
          <v-list-item-title>
            {{seat.practitioner.user.first_name}} {{seat.practitioner.user.last_name}}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>

  <v-divider class="my-10" />
  <v-card v-if="result.is_active" class="mx-3 mb-5" >
    <v-card-title class='overline py-1 red lighten-2' >
      Danger Zone
    </v-card-title>
    <v-divider/>
    <v-card-actions >
      <v-spacer/>
      <v-btn @click="cancellationdialog=true" color="error" >Cancel account</v-btn>
    </v-card-actions>

    <v-dialog width="460" v-model="cancellationdialog" >
      <action-component
        v-model="cancelReq"
        @close="cancellationdialog=false"
        @done="cancellationdialog=false"
        @ok="get"
        :payload="cancellationPayload"
        successmessage="Your account has been cancelled"
        cta-text="Cancel my account" cta-color="error" >
        <template slot="card-text" >
          <h3 class="subtitle-1 pa-2" > What happens when I cancel my account?</h3>
          <ul>
            <li>When you cancel your account, your subscription will be cancelled immediately and no more payments will be taken against your credit card.</li>
            <li>Your account will be placed in read-only mode. You can still log into your account and access your data, but you cannot create new appointments.</li>
            <li>After a period of time (over 1 year), your account will be archived and your data deleted.</li>
            <li>You are of course welcome to reactivate your account at any time.</li>
          </ul>
        </template>
      </action-component>

    </v-dialog>
  </v-card>

  <!-- <pre v-text="req.result" class="caption" /> -->
</v-card>
</template>
<script>
import { mapGetters } from "vuex"
import ActionComponent from "@/components/actions/ActionComponent.vue"
// import BillingHistory from './BillingHistory.vue'

export default {
  name: 'Billing',
  components: {
    ActionComponent
    // BillingHistory
  },
  data () {
    return {
      businessId: null,
      req: {
        resource: 'ag.business'
      },
      cancelReq: {
        resource: 'ag.team',
        extra: 'cancel_account'
      },
      reactivateReq: {
        resource: 'ag.team',
        extra: 'cancel_account'
      },
      cancellationdialog: false
    }
  },
  methods: {
    get () {
      this.req.resourceId = this.businessId
      this.$request('get', this.req)
    },
    reactivate () {
      this.reactivateReq.data = {
        actor: this.meId,
        business: this.businessId,
        reactivate: true
      }
      this.$request('save', this.reactivateReq)
    }
  },
  watch: {
    businessId: {
      immediate: true,
      handler () {
        if (this.businessId) { this.get() }
      }
    },
    businesses: {
      immediate: true,
      handler () {
        if (this.businesses && this.businesses.length > 0) {
          this.businessId = this.businesses[0].id
        }
      }
    }
  },
  computed: {
    ...mapGetters ('identity', ['businesses', 'lookups']),
    result () {
      return this.getObjectPath(this.req, 'result', {})
    },
    accountOwner () {
      return this.getObjectPath(this.result, 'billable_practitioner.user', {})
    },
    seats () {
      return this.getObjectPath(this.result, 'seats', [])
    },
    activeSeats () {
      return this.seats.filter((seat) => { return seat.active === true })
    },
    deactivatedSeats () {
      return this.seats.filter((seat) => { return seat.active === false })
    },
    currency () {
      return this.getObjectPath(this.result, 'package.currency')
    },
    standardPackagePrice () {
      return this.getObjectPath(this.result, 'package.base_price')
    },
    seatPriceTotal () {
      return this.getObjectPath(this.result, 'calculated_total_seat_price')
    },
    cancellationPayload () {
      return {
        actor: this.meId,
        business: this.businessId
      }
    }
    // total () {
    //   let base = this.result.base_price || 0
    //   return (parseInt(base) + parseInt(this.seatPriceTotal))
    // }
  }
}
</script>
